import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Measurements from './pages/Measurements';
import People from './pages/People';
import Privacy from './pages/Privacy';
import LoginSuccess from './components/LoginSuccess';
import './styles/GlobalTheme.css';
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* LoginSuccess must remain outside Layout for Chrome extension bridge */}
          <Route path="/login-success" element={<LoginSuccess />} />

          {/* All other routes use the shared Layout */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route
            path="/measurements"
            element={
              <Layout>
                <ProtectedRoute>
                  <Measurements />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/people"
            element={
              <Layout>
                <ProtectedRoute>
                  <People />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
          {/* Legacy redirects */}
          <Route path="/profile" element={<Navigate to="/measurements" replace />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/signup" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
